import { render, staticRenderFns } from "./DashboardUpdatesCard.vue?vue&type=template&id=ca677870&scoped=true&"
import script from "./DashboardUpdatesCard.vue?vue&type=script&lang=js&"
export * from "./DashboardUpdatesCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUpdatesCard.vue?vue&type=style&index=0&id=ca677870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca677870",
  null
  
)

export default component.exports